












































import { defineComponent, ref } from '@vue/composition-api';
import Form from '@components/Form/index.vue';
import ElTableComp from '@components/ElTableComp/index.vue';

export default defineComponent({
  name: 'SinglePage',
  props: {
    paginationOptions: {
      type: Object,
      default: {}
    },
    searchFormOptions: {
      type: Object,
      default: {}
    },
    tableOptions: {
      type: Object,
      default: {}
    }
  },
  components: {
    Form,
    ElTableComp
  },
  setup(props) {
    const form = ref({});
    if (props?.searchFormOptions?.form) {
      form.value = Object.assign({}, props.searchFormOptions.form);
    }

    const doGetTable = () => {
      const pageInfo = {
        size: props?.paginationOptions?.size,
        current: props?.paginationOptions?.current
      };
      props.tableOptions?.getTableData(Object.assign(props.searchFormOptions?.form, pageInfo));
    };

    const onSearch = () => {
      if (props?.paginationOptions) {
        props.paginationOptions.current = 1;
        // props.paginationOptions.size = 10;
      }
      if (props?.tableOptions?.getTableData && typeof props.tableOptions.getTableData === 'function' && props?.searchFormOptions) {
        props.searchFormOptions.form = Object.assign({}, form.value);
        doGetTable();
      }
    };

    const handleSizeChange = (size: number) => {
      if (props?.paginationOptions) {
        props.paginationOptions.size = size;
        props.paginationOptions.current = 1;
      }
      if (props?.tableOptions?.getTableData && typeof props.tableOptions.getTableData === 'function') {
        doGetTable();
      }
    };

    const handleCurrentChange = (page: number) => {
      if (props?.paginationOptions) {
        props.paginationOptions.current = page;
      }
      if (props?.tableOptions?.getTableData && typeof props.tableOptions.getTableData === 'function') {
        doGetTable();
      }
    };

    return {
      form,
      onSearch,
      handleCurrentChange,
      handleSizeChange,
    };
  }
});
